import { WprBaseValidator } from '../../../wpr-framework/view/validation/WprBaseValidator';

/**
 * パスワードバリデータ
 */
export class PassAvailableCharacterValidator extends WprBaseValidator {
	// コンストラクタ  -----------------------------------------------------------
	public constructor() {
		super('パスワード使用可能文字');
	}
	// --------------------------------------------------------------------------

	// override メソッド  --------------------------------------------------------
	/**
	 * 入力値チェック
	 * @param value 入力値
	 * @param option チェックオプション
	 * @returns trueの場合、成功
	 */
	public checkValidValue(value: any, option?: any): boolean {
		if (!value)
			return true;
		if (typeof (value) === 'string' || value instanceof String) {
			if (value.match('^[a-zA-Z0-9-_.*!#$%&+/=?^`{|}~@]*$') != null)
				return true;
		}
		return false;
	}

	/**
	 * エラーメッセージ取得
	 * @param option オプション
	 * @returns エラーメッセージ
	 */
	public getErrorMessage(option?: any): string {
		return '半角英数で入力してください';
	}
	// --------------------------------------------------------------------------
}
